import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import Text from '@/components-latest/primitives/Text'
import CommonModal from '@/components-latest/shared/Modals/CommonModal'

import Styles from './DisableConfirmation.module.scss'

interface IDisableConfirmation {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  children?: React.ReactNode
  title?: string
  description?: string
  cancelText?: string
  confirmText?: string
}

const DisableConfirmation: React.FC<IDisableConfirmation> = ({
  onConfirm,
  children,
  title,
  description,
  cancelText,
  confirmText,
  onOpenChange,
  open
}) => {
  const { t } = useTranslation()

  const closeModal = () => onOpenChange(false)
  const handleConfirm = () => {
    onConfirm()
    closeModal()
  }

  const footer = (
    <div className={Styles.footer}>
      <Button
        size="medium"
        variant="tertiary"
        type="button"
        onClick={closeModal}>
        {cancelText || t('common.modal.cancel')}
      </Button>
      <Button
        size="medium"
        variant="primary"
        type="button"
        onClick={handleConfirm}>
        {confirmText || t('common.modal.confirm')}
      </Button>
    </div>
  )

  const body = (
    <div className={Styles.body}>
      <Text variant="nextSubtitle" gutter={8}>
        {description}
      </Text>
    </div>
  )

  return (
    <CommonModal
      width={376}
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      footer={footer}
      body={body}>
      {children}
    </CommonModal>
  )
}

export default DisableConfirmation
